module.exports = __webpack_public_path__ + "static/media/na.d0472bd9.png";